import {useTranslation} from 'react-i18next';
import {AssistantPanel, ExternalLink} from '@chekinapp/ui';
import {formatSourceLabel} from 'utils/travelGuide';
import {useVelaTripStore} from '../hooks/useVelaTripStore';

function bySite(urls: string[]) {
  const firstPerHost = new Map<string, string>();
  for (const url of urls) {
    const host = formatSourceLabel(url);
    if (!firstPerHost.has(host)) firstPerHost.set(host, url);
  }
  return Array.from(firstPerHost, ([host, url]) => ({host, url}));
}

function VelaTripProvenance() {
  const {t} = useTranslation();
  const trip = useVelaTripStore(state => state.trip);

  if (!trip) return null;

  const sources = bySite(trip.sources.filter(Boolean));

  return (
    <>
      {!!trip.assumptions.length && (
        <AssistantPanel.Section label={t('travel_guide.tuned_for')}>
          <ul className="flex list-disc flex-col gap-1.5 pl-4 text-[12.5px] leading-[18px] text-[var(--chekin-text-secondary)]">
            {trip.assumptions.map(assumption => (
              <li key={assumption}>{assumption}</li>
            ))}
          </ul>
        </AssistantPanel.Section>
      )}

      {!!sources.length && (
        <AssistantPanel.Section label={t('travel_guide.sources_title')}>
          <div className="flex flex-col gap-2">
            <ul className="flex flex-col gap-1.5">
              {sources.map(({host, url}) => (
                <li key={host}>
                  <ExternalLink href={url} className="text-[12px] leading-[18px]">
                    {host}
                  </ExternalLink>
                </li>
              ))}
            </ul>
            <p className="text-[11.5px] leading-[16px] text-[var(--chekin-text-tertiary)]">
              {t('travel_guide.sources_note')}
            </p>
          </div>
        </AssistantPanel.Section>
      )}
    </>
  );
}

export {VelaTripProvenance};
